const get_started = {
    page_title: '開始上手',
    title: '成功開發身份方案，我們先來探索一番',
    subtitle: '一些快速獲取 Logto 價值的事情',
    develop: {
        title: '開發：花 5 分鐘集成您的應用程式',
        title_cloud: '開發：在幾分鐘內安全集成您的應用程式',
        subtitle_cloud: '或花 5 分鐘用我們預先構建的 SDK 和教程集成您的應用程式。',
        try_mcp: '試試用 MCP 一個提示完成整合',
    },
    customize: {
        title: '自訂：提供出色的登錄體驗',
        preview: {
            title: '查看您剛自訂的登錄體驗的實時預覽',
            subtitle: '立即嘗試 Logto 登錄體驗，了解其工作原理',
        },
        connector: {
            title: '添加更多連接器以支持更多社交登錄方式',
            subtitle: '嘗試無密碼登錄，為您的客戶啟用安全、無摩擦的體驗',
        },
        continue_customizing: '繼續自訂',
        try_now: '立即嘗試',
        add_more: '添加更多',
    },
    secure: {
        title: '安全：保護您的資源',
    },
    manage: {
        title: '管理：為您的產品和用戶定義訪問控制',
        rbac: {
            title: '添加基於角色的訪問控制以保護您的資源',
            subtitle: '通過可擴展的角色授權，來控制不同用例的資源',
        },
        create_roles: '創建角色',
    },
    convert_to_production: {
        card_title: '準備好上線了嗎？不要忘記發佈你的生產環境設置！',
        title: '不要讓你的專案卡在開發模式',
        subtitle: '你正在使用一個開發租戶進行免費測試。要上線，請創建或轉換為生產租戶。需要定制方案嗎？<a>聯絡我們</a>',
        convert_button: '轉換為生產租戶',
    },
    oss_cloud: {
        try: {
            title: '跳過維運工作，免費試用 Logto Cloud',
            badge: '推薦',
            description: '取得一個無需維護的全託管 Logto，同時享有 MCP 驅動的快速整合、多租戶支援、團隊協作，以及所有進階功能。可免費開始，無需信用卡。',
            action: '探索 Logto Cloud',
        },
        private_cloud: {
            title: '需要合規支援或客製化部署？',
            card_title: '私有雲',
            description: '取得一個專屬的 Logto 實例，具備完整的資料隔離、自訂網域與 SLA 保證。非常適合對資料駐留或合規有嚴格要求的企業。基礎設施由我們負責，你可以專注於產品本身。',
        },
    },
    view_all: '查看全部 →',
};
export default Object.freeze(get_started);
